import { Option } from '../../../multi-selector/multi-selector';
import { OptionInfoField } from '../../../option-info-popover';

export function modelToOptions({
  model,
}: {
  model?: { infoFields?: OptionInfoField[]; value: string; item: string }[];
}): Option[] {
  if (!model) return [];
  return model.map(({ value, item, infoFields }) => ({ value, label: item, infoFields }));
}
